var moduleMap = {
	"./Loader": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(388)]).then(() => (() => ((__webpack_require__(5388)))));
	},
	"./ImedilLoader": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(396)]).then(() => (() => ((__webpack_require__(396)))));
	},
	"./HeroSlider": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(167), __webpack_require__.e(635), __webpack_require__.e(797)]).then(() => (() => ((__webpack_require__(6797)))));
	},
	"./SlickSlider": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(635), __webpack_require__.e(833)]).then(() => (() => ((__webpack_require__(7833)))));
	},
	"./SplideSlider": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(588)]).then(() => (() => ((__webpack_require__(588)))));
	},
	"./Section": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(482)]).then(() => (() => ((__webpack_require__(7482)))));
	},
	"./Title": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(418)]).then(() => (() => ((__webpack_require__(1418)))));
	},
	"./Faq": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(402)]).then(() => (() => ((__webpack_require__(6402)))));
	},
	"./CountDown": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(153), __webpack_require__.e(184)]).then(() => (() => ((__webpack_require__(8184)))));
	},
	"./OfferCard": () => {
		return Promise.all([__webpack_require__.e(656), __webpack_require__.e(167), __webpack_require__.e(153), __webpack_require__.e(333)]).then(() => (() => ((__webpack_require__(8333)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});